<template>
  <PublicPage title="Qui se cache derrière Citron Digital ?" crumb="Informations">
    <div class="who-grid">
      <section>
        <h2>Un expert du digital</h2>
        <p>
          Je m'appelle Franck Besson, développeur logiciel avec plus de 10 ans d'expérience dans le digital.
          Depuis plus de 5 ans, j’accompagne entreprises et PME dans la création de solutions SaaS,
          d’applications web et d’outils métiers, notamment dans des environnements exigeants.
        </p>
      </section>

      <section>
        <h2>Une mission</h2>
        <p>
          Avec Citron Digital, fondé en 2020, mon objectif est de simplifier la gestion des entreprises grâce à un logiciel
          français de facturation électronique, gestion client, prospection commerciale et comptabilité,
          sécurisé et conforme aux exigences actuelles.
        </p>
      </section>
    </div>

    <p class="more">
      <a class="pub-btn pub-btn--ink" :href="aboutUrl">Voir mon parcours</a>
      <a class="pub-btn pub-btn--ghost" :href="productUrl">Présenter le logiciel</a>
    </p>
  </PublicPage>
</template>

<script>
    import PublicPage from "@/components/public/PublicPage.vue";
    import {SITE_ABOUT_URL, SITE_PRODUCT_URL} from "@/components/public/siteLinks";
    import {useHead} from "@vueuse/head";

    export default {
      name: 'WhoView',
      components: {PublicPage},
      data() {
        return {
          aboutUrl: SITE_ABOUT_URL,
          productUrl: SITE_PRODUCT_URL,
        }
      },
      mounted() {
        useHead({
          title: 'À propos - Logiciel de facturation électronique développé par Citron Digital',
          meta: [
            {
              name: 'description',
              content: 'Découvrez qui développe ce logiciel français de facturation électronique, gestion client, prospection et comptabilité : Citron Digital.'
            }
          ]
        });
      }
    }
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/public.styl';

.who-grid
  display grid
  gap 40px
  section
    padding-top 16px
    border-top 2px solid PUB_INK
  h2
    margin 0
    color PUB_INK
    font-family PUB_FONT_DISPLAY
    font-weight 400
    font-size clamp(1.5rem, 3vw, 1.9rem)
    line-height 1.2
  p
    margin 12px 0 0
    max-width 52ch
    color PUB_INK
    font-family PUB_FONT_TEXT
    line-height 1.7

.more
  display flex
  flex-wrap wrap
  gap 12px
  margin 48px 0 0

@media (min-width: 1000px)
  .who-grid
    grid-template-columns 1fr 1fr
    gap 56px
</style>
